import styled from 'styled-components';
import {
    StrategyPageHeader,
    StrategyWideCardColumn,
    StrategyTableContainer,
    StrategyTableWrapper,
} from '../../Strategy/styles';

export const PlacarStack = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    gap: 44px;

    @media (min-width: 768px) {
        gap: 60px;
    }
`;

export const PlacarPageHeader = styled(StrategyPageHeader)`
    margin-bottom: 0 !important;
`;

export const PlacarWideCardColumn = styled(StrategyWideCardColumn)`
    margin-top: 0 !important;
`;

export const FilterSection = styled.div`
    margin-bottom: 0;
`;

export const FilterTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(200, 210, 235, 0.9);
    margin-bottom: 16px;

    i {
        color: #f29205;
    }
`;

export const FilterRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 16px 20px;
`;

export const FilterField = styled.div`
    flex: 1 1 200px;
    min-width: 160px;
    max-width: 280px;

    .MuiFormControl-root {
        width: 100%;
    }
`;

export const FilterActions = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: stretch;
    align-self: flex-end;

    .MuiButton-root {
        min-height: 48px !important;
        height: 48px !important;
        padding: 0 22px !important;
        box-sizing: border-box !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    @media (min-width: 768px) {
        .MuiButton-root {
            min-height: 52px !important;
            height: 52px !important;
        }
    }

    @media (min-width: 992px) {
        .MuiButton-root {
            min-height: 56px !important;
            height: 56px !important;
        }
    }
`;

export const PageInner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .MuiOutlinedInput-root fieldset {
        border-width: 1px !important;
        border-color: rgba(242, 146, 5, 0.32) !important;
    }

    .MuiOutlinedInput-root:hover fieldset {
        border-color: rgba(242, 146, 5, 0.5) !important;
    }

    .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #00d4ff !important;
    }
`;

export const calcPrimaryButtonStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 22px',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: 14,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.35)',
    minWidth: 120,
    textTransform: 'none',
    transition: 'all 0.25s ease',
};

/**
 * Sem padding lateral extra do StrategyTableWrapper — alinha a tabela ao conteúdo do filtro
 * (só o padding do card do produto).
 */
export const PlacarTableWrap = styled(StrategyTableWrapper)`
    margin-top: 0 !important;
    padding: 0 !important;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
`;

/** Tabela em largura total do bloco interno do card */
export const PlacarTableContainer = styled(StrategyTableContainer)`
    width: 100% !important;
    max-width: 100%;

    .MuiTable-root {
        width: 100% !important;
        min-width: 100% !important;
        table-layout: auto;
    }

    @media (max-width: 599px) {
        .MuiTable-root {
            min-width: 600px !important;
        }
    }
`;

/** Espaço entre filtro e tabela */
export const TableSection = styled.div`
    width: 100%;
    margin-top: 36px;
    padding-top: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
`;
